/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import CircularLoading from "../../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import FlatList from "flatlist-react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles(() => ({
  customTooltip: {
    fontSize: "clamp(0.9rem, 1.2vw, 1.2rem)",
    backgroundColor: "white",
    color: "#0784ba",
    borderRadius: 4,
    padding: "8px 14px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
  },
  arrow: {
    color: "white", // arrow background same as tooltip
  },
}))
const BookingHistory = () => {
  const { api } = useContext(FirebaseContext);
  const { fetchMedicalHistory, updateBooking } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const bookinglistdata = useSelector((state) => state.bookinglistdata);

  const [accepted, setAccepted] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [expired, setExpired] = useState([]);
  const [activeTab, setActiveTab] = useState("1");

  const [searchDate, setSearchDate] = useState(""); 
  const classes = useStyles();
 useEffect(() => {
  if (!bookinglistdata.bookings) return;

  const acc = [];
  const comp = [];
  const exp = [];

  bookinglistdata.bookings.forEach((booking) => {
    if (booking?.doctor?.uid !== auth.info.uid) return;

    // Filter by searchDate if set
    
    if (searchDate) {
      const bookingDate = new Date(booking.eventDate).toISOString().split("T")[0];
      if (bookingDate !== searchDate) return;
    }

    if (booking.status === "ACCEPTED") {
      if (booking.endDate) {
        const end = new Date(booking.endDate).getTime();
        const now = Date.now();
        if (now > end + 30 * 60 * 1000) {
          exp.push(booking);
        } else {
          acc.push(booking);
        }
      } else {
        acc.push(booking);
      }
    } else if (booking.status === "COMPLETE") {
      comp.push(booking);
    }
  });

  setAccepted(acc);
  setCompleted(comp);
  setExpired(exp);
}, [bookinglistdata.bookings, auth.info.uid, searchDate]);


  const SendBookingToCompleted = (booking) => {
    const updated = { ...booking, status: "COMPLETE" };
    console.log("this is the update to be completed", updated);
    dispatch(updateBooking(updated));
  };

    const RemoveFromCompleted = (booking) => {
    const updated = { ...booking, status: "ACCEPTED" };
    console.log("this is the update to be completed", updated);
    dispatch(updateBooking(updated));
  };

    const Cancel = (booking) => {
    const updated = { ...booking, status: "CANCELED" };
    console.log("this is the update to be completed", updated);
    dispatch(updateBooking(updated));
  };


  const renderBooking = (Booking, index, section) => {
    // map status to border colour
    const statusColors = {
      NEW: "#ff0000",
      PENDING: "#6f42c1",
      ACCEPTED: "#28a745",
      COMPLETE: "#007bff",
      EXPIRED: "#6c757d",
      CANCELED: "#aac142ff",
    };

    // if in expired tab, override status
    const effectiveStatus = section === "expired" ? "EXPIRED" : Booking.status;
    const borderColor = statusColors[effectiveStatus] || "#000";


    return (
      <Col md="4" key={index}>
        <Card style={{ border: `2px solid ${borderColor}`, borderRadius: "8px" }}>
          <CardHeader>
            <CardTitle tag="h4">
              {/* <div className="picture">
                <img
                  alt="..."
                  className="picture-src"
                  src={Booking.patientImage}
                />
              </div>{" "} */}
              {Booking.patientName}
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row mb="12">
              <Col md="12">
                <FormGroup>
                  <span>Type of Booking Service: </span>
                  <p className="description">{Booking.serviceType}</p>
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup>
                  <span>Date and Time of Booking: </span>
                  <p className="description">{Booking.eventDate}</p>
                </FormGroup>
              </Col>
            </Row>
            <Row mb="12">
              <Col md="12">
                <FormGroup>
                  <span>Booking Status: </span>
                  <p className="description">{effectiveStatus}</p>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>

          <CardFooter className="d-flex justify-content-between">
            {/* Show View Booking only if not expired */}
            {section !== "expired" && (
              <Button
                color="primary"
                onClick={() => {
                  navigate("/bookinginformation", { state: { Booking } });
                  dispatch(fetchMedicalHistory(Booking.patient));
                }}
              >
                View Booking
              </Button>
            )}

            {section === "expired" && (
              <Tooltip
                title="Moving the booking to completed. You may edit it there."
                arrow
                classes={{ tooltip: classes.customTooltip, arrow: classes.arrow }}
              >
                <Button
                  color="success"
                  onClick={() => SendBookingToCompleted(Booking)}
                >
                  Complete
                </Button>
              </Tooltip>
            )}

             {section === "completed" && (
              <Tooltip
                title=" ."
                arrow
                classes={{ tooltip: classes.customTooltip, arrow: classes.arrow }}
              >
                <Button
                  color="success"
                  onClick={() => RemoveFromCompleted(Booking)}
                >
                  Remove from Completed
                </Button>
              </Tooltip>
            )}
            {section === "accepted" && (
              <Tooltip
                title=" ."
                arrow
                classes={{ tooltip: classes.customTooltip, arrow: classes.arrow }}
              >
                <Button
                  color="success"
                  onClick={() => Cancel(Booking)}
                >
                  Cancel Booking
                </Button>
              </Tooltip>
            )}
          </CardFooter>
        </Card>
      </Col>
    );
  };


  return bookinglistdata.loading ? (
    <CircularLoading />
  ) : (
    <Row>
      <Col md="12">
        <Card>
          <CardHeader>
            <CardTitle tag="h4">CONSULTATIONS</CardTitle>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  style={{
                    backgroundColor: activeTab === "1" ? "#28a745" : "transparent",
                    color: activeTab === "1" ? "#fff" : "#28a745",
                    borderColor: "#28a745",
                    fontWeight: "600",
                    transition: "all 0.3s",
                  }}
                  onClick={() => setActiveTab("1")}
                >
                  Accepted ({accepted.length})
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  style={{
                    backgroundColor: activeTab === "2" ? "#007bff" : "transparent",
                    color: activeTab === "2" ? "#fff" : "#007bff",
                    borderColor: "#007bff",
                    fontWeight: "600",
                    transition: "all 0.3s",
                  }}
                  onClick={() => setActiveTab("2")}
                >
                  Complete ({completed.length})
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  style={{
                    backgroundColor: activeTab === "3" ? "#6c757d" : "transparent",
                    color: activeTab === "3" ? "#fff" : "#6c757d",
                    borderColor: "#6c757d",
                    fontWeight: "600",
                    transition: "all 0.3s",
                  }}
                  onClick={() => setActiveTab("3")}
                >
                  No Show  ({expired.length})
                </NavLink>
              </NavItem>
            </Nav>

              <Row style={{ marginTop: "15px", padding: "0 15px" }}>
              <Col md="12" className="d-flex align-items-center">
                <label htmlFor="searchDate" style={{ marginRight: "10px", marginBottom: 0, fontWeight: "bold" }}>
                  Filter by Date:
                </label>
                <input
                  id="searchDate"
                  type="date"
                  value={searchDate}
                  onChange={(e) => setSearchDate(e.target.value)}
                  style={{ 
                    padding: "5px 10px", 
                    borderRadius: "5px", 
                    border: "1px solid #ccc",
                    marginRight: "10px",
                    flexGrow: 1,
                    maxWidth: "200px"
                  }}
                />
                {searchDate && (
                  <Button color="secondary" onClick={() => setSearchDate("")} size="sm">
                    Clear
                  </Button>
                )}
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Row>
                  <FlatList
                    list={accepted}
                    renderItem={(item, i) => renderBooking(item, i, "accepted")}
                    renderWhenEmpty={() => (
                      <div>No accepted bookings found.</div>
                    )}
                  />
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <FlatList
                    list={completed}
                    renderItem={(item, i) => renderBooking(item, i, "completed")}
                    renderWhenEmpty={() => (
                      <div>No completed bookings found.</div>
                    )}
                  />
                </Row>
              </TabPane>
              <TabPane tabId="3">
                <Row>
                  <FlatList
                    list={expired}
                    renderItem={(item, i) => renderBooking(item, i, "expired")}
                    renderWhenEmpty={() => (
                      <div>No expired bookings found.</div>
                    )}
                  />
                </Row>
              </TabPane>
                 <TabPane tabId="4">
                <Row>
                  <FlatList
                    list={expired}
                    renderItem={(item, i) => renderBooking(item, i, "canceled")}
                    renderWhenEmpty={() => (
                      <div>No expired bookings found.</div>
                    )}
                  />
                </Row>
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default BookingHistory;
